/**
 * CSS样式注入函数
 * @returns
 */
const injectStyles = (): void => {
  if (document.querySelector('style[data-error-overlay]')) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute('data-error-overlay', 'true');
  style.textContent = `
      .resource_error-container {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .resource_error-container .icon {
        width: 240px;
      }
      .resource_error-container .icon img {
        display: block;
        width: 100%;
      }
      .resource_error-container h3 {
        text-align: center;
        font-size: 14px;
        color: #999;
        padding: 15px 0;
      }
      .resource_error-container .button {
        cursor: pointer;
        width: 120px;
        height: 36px;
        background-color: #f03036;
        border-radius: 4px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        user-select: none;
      }
      .resource_error-container .button:hover {
        background-color: #f56e72;
      }
    `;
  document.head.appendChild(style);
};

/**
 * 浏览器中刷新当前页面
 */
const reloadInBrowser = (): void => {
  const url: URL = new URL(window.location.href);
  const timeStamp: number = new Date().getTime();
  url.searchParams.set('t', timeStamp.toString());
  window.location.replace(url.toString());
};

/**
 * ios客户端内部强制刷新
 */
const reloadInIos = (): void => {
  const url: URL = new URL(window.location.href);
  url.searchParams.set('ZHSPECIAL', '64');
  window.location.replace(url.toString());
};

/**
 * 是否在APP内部
 */
const isInApp = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  return ua.includes('hrhg_new_');
};

/**
 * 是否是安卓系统
 */
const isAndroid = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  let isAndroid: boolean = ua.includes('android');
  return isAndroid;
};

/**
 * 潘墩是否是ios系统
 */
const isIOS = (): boolean => {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  const iosDevices: string[] = ['iphone', 'ipad', 'ipod'];
  return iosDevices.some((device) => ua.includes(device));
};

/**
 * 创建遮罩层
 */
const createOverlay = (): void => {
  injectStyles();

  if (document.querySelector('.resource_error-container')) {
    return;
  }

  const errorIcon = document.createElement('img');
  errorIcon.src = '//zhyt-hrhg.9635.com.cn/images/resource_error.png';

  const errorIconDiv = document.createElement('div');
  errorIconDiv.appendChild(errorIcon);
  errorIconDiv.setAttribute('class', 'icon');

  const errorText = document.createElement('h3');
  errorText.innerText = '页面加载异常';

  const reloadButton = document.createElement('div');
  reloadButton.id = 'errorReloadButton';
  reloadButton.innerText = '重新加载';
  reloadButton.setAttribute('class', 'button');

  const resourceErrorContainer = document.createElement('div');
  resourceErrorContainer.setAttribute('class', 'resource_error-container');

  resourceErrorContainer.appendChild(errorIconDiv);
  resourceErrorContainer.appendChild(errorText);
  resourceErrorContainer.appendChild(reloadButton);

  document.body.appendChild(resourceErrorContainer);

  const errorReloadButtonEle = document.getElementById('errorReloadButton');
  if (!errorReloadButtonEle) {
    return;
  }

  errorReloadButtonEle.onclick = () => {
    /**
     * app客户端内部
     */
    if (isInApp()) {
      if (isAndroid()) {
        reloadInBrowser();
        return;
      }
      if (isIOS()) {
        reloadInIos();
        return;
      }
      return;
    }

    /**
     * PC客户端内的处理
     */
    if (window.ClientBridge && window.ClientBridge.clearchace) {
      window.ClientBridge.clearchace();
      return;
    }

    reloadInBrowser();
  };
};

/**
 * 展示错误遮罩层
 */
export const showErrorOverlay = (): void => {
  if (document.querySelector('.resource_error-container')) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createOverlay);
  } else {
    createOverlay();
  }
};

/**
 * 隐藏错误遮罩层
 */
export const hideErrorOverlay = (): void => {
  const overlay = document.querySelector('.resource_error-container');
  if (overlay) {
    overlay.remove();
  }
};
